import { createApi } from '@reduxjs/toolkit/query/react';
import { authBaseQuery } from '../utils/authBaseQuery';

const baseUrl =
  process.env.NEXT_PUBLIC_USE_SECURITY === 'true'
    ? process.env.NEXT_PUBLIC_API_SECURITY
    : process.env.NEXT_PUBLIC_API_EVENT;

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: authBaseQuery({
    baseUrl,
  }),
  endpoints: (builder) => ({
    signIn: builder.mutation({
      query: (credentials) => ({
        url: 'checkout-users-command/api/v1/signIn',
        method: 'POST',
        body: credentials,
      }),
    }),
    signUp: builder.mutation({
      query: ({ name, phone, email, password }) => ({
        url: 'checkout-users-command/api/v1/signUp',
        method: 'POST',
        body: {
          fist_name: name,
          phone_numer: phone,
          email,
          hash_password: password,
        },
      }),
    }),
    signUpGuest: builder.mutation({
      query: ({
        name,
        phone,
        email,
        token,
        event_id,
        media,
        bookingOrder,
        bookingId,
        preRegisterId
      }) => ({
        url: 'checkout-users-command/api/v1/signUp',
        method: 'POST',
        body: {
          ...(name ? { fist_name: name } : {}),
          ...(phone ? { phone_numer: phone } : {}),
          ...(email ? { email } : {}),
          ...(token ? { token } : {}),
          ...(preRegisterId ? { pre_register_id: preRegisterId } : {}),
          event_id,
          guest: true,
          hash_password: '@TestBoletia2029',
          media,
          booking_order: bookingOrder,
          booking_id: bookingId,
        },
      }),
    }),
    sweepstakesRegister: builder.mutation({
      query: (body) => ({
        url: 'checkout-users-command/api/v1/customizations',
        method: 'POST',
        body,
      }),
    }),
    verifyCode: builder.mutation({
      query: ({ code, email, bookingOrder, bookingId }) => ({
        url: 'checkout-users-command/api/v1/users/verification',
        method: 'PUT',
        body: {
          email,
          code,
          guest: true,
          booking_order: bookingOrder,
          booking_id: bookingId,
        },
      }),
    }),
    resendCode: builder.mutation({
      query: ({ email, media }) => ({
        url: 'checkout-users-command/api/v1/users/resend-verification-code',
        method: 'PUT',
        body: {
          email,
          guest: true,
          media,
        },
      }),
    }),
  }),
});

export const {
  useSignInMutation,
  useSignUpMutation,
  useSignUpGuestMutation,
  useSweepstakesRegisterMutation,
  useVerifyCodeMutation,
  useResendCodeMutation,
} = authApi;
